import { cn } from '@ordo/ui/cn'
import { ChevronDown, type LucideIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button } from '@/components/chefs/button'

interface ChipButtonProps extends React.ComponentProps<typeof Button> {
  Icon?: LucideIcon
  showCaret?: boolean
}

export const CHIP_CLASS =
  'h-9 gap-2 rounded-full border-border bg-background px-5 text-sm font-medium text-foreground shadow-xs hover:bg-muted/50'

export const CHIP_CLASS_PRIMARY =
  'h-9 gap-2 rounded-full border-transparent bg-primary px-5 text-sm font-medium text-primary-foreground shadow-xs hover:bg-primary/90 hover:text-primary-foreground'

export const CHIP_CLASS_LG =
  'h-10 gap-2 rounded-full border-border bg-background px-8 text-sm font-medium text-foreground shadow-xs hover:bg-muted/50'

export const CHIP_CLASS_LG_PRIMARY =
  'h-10 gap-2 rounded-full border-transparent bg-primary px-8 text-sm font-medium text-primary-foreground shadow-xs hover:bg-primary/90 hover:text-primary-foreground'

export const CHIP_CLASS_SM =
  'h-7 gap-1.5 rounded-full border-border bg-background px-3 text-xs font-medium text-foreground shadow-xs hover:bg-muted/50 data-[size=default]:h-7 data-[size=sm]:h-7'

export const CHIP_CLASS_SM_PRIMARY =
  'h-7 gap-1.5 rounded-full border-transparent bg-primary px-3 text-xs font-medium text-primary-foreground shadow-xs hover:bg-primary/90 hover:text-primary-foreground data-[size=default]:h-7 data-[size=sm]:h-7'

export const ChipButton = forwardRef<HTMLButtonElement, ChipButtonProps>(
  ({ Icon, showCaret, children, className, ...props }, ref) => (
    <Button ref={ref} type="button" variant="outline" size="sm" className={cn(CHIP_CLASS, className)} {...props}>
      {Icon ? <Icon className="h-4 w-4" strokeWidth={1.5} /> : null}
      {children ? <span>{children}</span> : null}
      {showCaret ? <ChevronDown className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} /> : null}
    </Button>
  ),
)
ChipButton.displayName = 'ChipButton'
